import React from "react";
import Counter from "./Counter";

const StatsSection = () => {
  return (
    <>
      <div className="container-fluid bg-theme-primary py-4 py-md-5 stats-section" style={{marginTop: '-5px'}}>
        <div className="container text-theme-light">
          <div className="section-header text-center mx-auto mb-5">
            <h1 className="section-heading text-theme-light">
              Measuring Our Growth
            </h1>
            {/* <p>
              Tempor ut dolore lorem kasd vero ipsum sit eirmod sit. Ipsum diam
              justo sed rebum vero dolor duo.
            </p> */}
          </div>
        </div>

        <div className="container">
          <div className="row g-4">
            <div className="col-3 col-sm-3">
              <div className="stat-item text-center text-theme-light">
                <h2 className="m-0">
                  <Counter end={56000} duration={2500} decimals={1} /> kg
                </h2>
                <p>Quantity Sold</p>
              </div>
            </div>
            <div className="col-3 col-sm-3">
              <div className="stat-item text-center text-theme-light">
                <h2 className="m-0">
                  <Counter end={548} duration={2000} />
                </h2>
                <p>Clients Serving</p>
              </div>
            </div>
            <div className="col-3 col-sm-3">
              <div className="stat-item text-center text-theme-light">
                <h2 className="m-0">
                  <Counter end={12} duration={2000} />
                </h2>
                <p>States Reached</p>
              </div>
            </div>
            <div className="col-3 col-sm-3">
              <div className="stat-item text-center text-theme-light">
                <h2 className="m-0">
                  <Counter end={5} duration={2000} />
                </h2>
                <p>Countries Reached</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatsSection;
